import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
 import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GroupIcon from "@mui/icons-material/Group";
import PaymentIcon from "@mui/icons-material/Payment"; // ícone de pagamento
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"; // ícone para "Ordem de Compra"
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { Card, CardContent, FormControl, } from '@mui/material';
import Chip from '@mui/material/Chip';
import Modal from '@mui/material/Modal';
import Cookies from 'js-cookie';
import {
    MaterialReactTable,
} from 'material-react-table';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo,   useState } from 'react';
import { useDropzone } from 'react-dropzone';
import {  useParams } from "react-router-dom";
import GeradorParcelas from './geradorParcelas';

import EditIcon from '@mui/icons-material/Edit';


import DeleteIcon from '@mui/icons-material/Delete';


import { format, isValid, parse } from 'date-fns';

import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Skeleton from '@material-ui/lab/Skeleton';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import {
    Box,
    Tooltip
} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import SwipeableViews from 'react-swipeable-views';


import NavegadorGestao from "../../../../../../components/NavBarGestao";
import api from '../../../../../../services/api';

import { Stack } from '@mui/material';

import { Button, InputLabel, MenuItem, Select } from "@material-ui/core";

import RequestQuoteIcon from '@mui/icons-material/Calculate';
import comprovante from '../../../../../../assets/imgs/comprovante.png';
import miniatura_pdf from '../../../../../../assets/imgs/miniatura_pdf.png';
import office from '../../../../../../assets/imgs/office.png';
import CadastrarNF from './cadastrarNF';
import CadastrarPagamento from './cadastrarPagamento';

import CadastrarAtributo from './cadastrarAtributo';

 

 
 
const dropzoneStyles = {
    border: '4px dashed #000000',
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
};




export default function GerenciarLancamento() {


    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const [openDadosPagamento, setOpenDadosPagamento] = useState(false);


 
    const [metodosPagamento, setMetodosPagamento] = useState([]);
 
    const [openGeradorParcelas, setOpenGeradorParcelas] = useState(false);



    const handleOpenGeradorParcelas = () => {
        setOpenGeradorParcelas(true);

    }

    const closeGeradorParcelas = () => {
        setOpenGeradorParcelas(false);

        listarInformacoes();

    }



    const handleAbrirProjeto = (id_ordem_compra) => {
        console.log("Abrir Projeto");
        window.open(
            "/gestao/administracao/ordensdecompras/editar/" + id_ordem_compra,
            "_blank" // abre em nova aba
        );
    };

    const handleAbrirOrdemCompra = (id_ordem_compra) => {
        console.log("Abrir Ordem de Compra");
        window.open(
            "/gestao/administracao/ordensdecompras/editar/" + id_ordem_compra,
            "_blank" // abre em nova aba
        );
    };


    const [openCadastrarPagamento, setOpenCadastrarPagamento] = useState(false);


    const [atualizarPagamento, setAtualizarPagamento] = useState(false);
    const [inUpdatePagamento, setInUpdatePagamento] = useState(null);

    const handleAtualizarPagamento = (row) => {

        row.data_pagamento = moment(row.data_pagamento).format('DD/MM/YYYY');
        setInUpdatePagamento(row);
        setAtualizarPagamento(true);
        setOpenCadastrarPagamento(false);
    }


    const handleOpenCadastrarPagamento = () => {
        setOpenCadastrarPagamento(true);

    }

    const closeCadastrarPagamento = () => {
        setOpenCadastrarPagamento(false);
        setAtualizarPagamento(false);
        listarInformacoes();
    }

    const [openCadastrarNF, setOpenCadastrarNF] = useState(false);
    const handleOpenCadastrarNF = () => {
        setOpenCadastrarNF(true);

    }

    const closeCadastrarNF = () => {
        setOpenCadastrarNF(false);
        listarInformacoes();
    }

    const [openCadastrarAtributo, setOpenCadastrarAtributo] = useState(false);
    const handleOpenCadastrarAtributo = () => {
        setOpenCadastrarAtributo(true);

    }

    const closeCadastrarAtributo = () => {
        setOpenCadastrarAtributo(false);
        listarInformacoes();
    }

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);

    }


    const handleChangeIndex = (index) => {
        setValue(index);
    };


    const [isUpdate, setIsUpdate] = useState(false);
    const [inUpdate, setInUpdate] = useState(null);



    function handleClickEditar(row) {
        row.data_vencimento = moment(row.data_vencimento).format('DD/MM/YYYY');
        setInUpdate(row);
        console.log("id parcela " + row.id_parcela);
        setIsUpdate(true);

    }





     const [loading, setLoading] = useState(true);
    const [objetoGerenciado, setObjetoGerenciado] = useState(null);

    const [isEditing, setIsEditing] = useState(false);
    const [newRow, setNewRow] = useState(createNewRow());




    function createNewRow() {
        const today = moment().format('DD/MM/YYYY');
        return {
            valor: 0.0,
            data_vencimento: today,
        };
    }

    const handleAddRow = () => {
        setNewRow(createNewRow());
        setIsEditing(true);

    };



    async function handleClickAtualizarLancamento() {
        try {

 



            const cadastro = {

                observacao: observacao,
            };

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.put('/v1/protected/financeiro/lancamentos/atualizar/' + idLancamento, cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Lançamento atualizado!");

                listarInformacoes();

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente!");
        }

    };




    async function handleClickDelete(row) {

        try {

            const confirmacao = window.confirm("Tem certeza que deseja excluir esta parcela?");

            if (confirmacao) {
                var id_user = Cookies.get('id_usuario');

                const token = Cookies.get('token');

                const headers = {
                    'Authorization': 'Bearer ' + token
                }

                await api.delete("v1/protected/financeiro/lancamentos/parcelas/excluir/" + row.id_parcela + "/" + id_user, {
                    headers: headers
                }).then(function (response) {

                    const deletado = response.data;
                    if (deletado) {
                        alert("Parcela Excluída!");
                        listarInformacoes();

                    } else {
                        alert("Erro de Conexão, tente novamente mais tarde");
                    }



                });
            }
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro na tentativa de exclusão: " + _err)

        }
    };


    async function handleClickDeleteAtributo(row) {

        try {

            const confirmacao = window.confirm("Tem certeza que deseja excluir este atributo financeiro?");

            if (confirmacao) {
                var id_user = Cookies.get('id_usuario');

                const token = Cookies.get('token');

                const headers = {
                    'Authorization': 'Bearer ' + token
                }

                await api.delete("v1/protected/financeiro/lancamentos/atributos/excluir/" + row.id_atributo + "/" + id_user, {
                    headers: headers
                }).then(function (response) {

                    const deletado = response.data;
                    if (deletado) {
                        alert("Atributo Excluído!");
                        listarInformacoes();

                    } else {
                        alert("Erro de Conexão, tente novamente mais tarde");
                    }



                });
            }
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro na tentativa de exclusão: " + _err)

        }
    };



    const columnsAtributos = useMemo(
        () => [
            {
                accessorKey: 'id_atributo',
                header: 'ID',
                size: 50,
            },
            {
                accessorKey: 'tipo',
                header: 'Tipo',
                size: 100,
                Cell: ({ cell }) => {
                    const tipo = cell.getValue();
                    return tipo === 0 ? 'Desconto' : tipo === 1 ? 'Juros' : 'Acréscimo';
                }
            },
            {
                accessorKey: 'valor',
                header: 'Valor',
                size: 100,
                Cell: ({ cell }) => {
                    const valor = cell.getValue();
                    return new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(valor || 0);
                }
            },
            {
                accessorKey: 'data',
                header: 'Data',
                size: 120,
                Cell: ({ row }) => {
                    return (
                        <span style={{ maxWidth: '120px' }}>
                            {moment(row.original.data).format('DD/MM/YYYY')}
                        </span>
                    );
                }
            },
            {
                accessorKey: 'descricao',
                header: 'Descrição',
                size: 600,
            }
        ],
        [],
    );

/*


    function returnDescricaoBanco(ib) {

        var texto = "Identificação: " + ib.identificacao +
            "\nTitular: " + ib.titular +
            "Banco: " + ib.banco +
            "\nAgência: " + ib.agencia +
            "\nConta: " + ib.conta +
            "\nDescrição: " + ib.descricao +
            "\nPix: " + ib.tipo_chave_1 + "=" + ib.chave_1;
        return texto;


    }
*/

    async function handleClickDeleteNotaFiscal(row) {

        try {

            const confirmacao = window.confirm("Tem certeza que deseja excluir esta Nota Fiscal?");

            if (confirmacao) {
                var id_user = Cookies.get('id_usuario');

                const token = Cookies.get('token');

                const headers = {
                    'Authorization': 'Bearer ' + token
                }

                await api.delete("v1/protected/financeiro/lancamentos/notasfiscais/excluir/" + row.id_nota_fiscal + "/" + id_user, {
                    headers: headers
                }).then(function (response) {

                    const deletado = response.data;
                    if (deletado) {
                        alert("Nota Fiscal Excluída!");
                        listarInformacoes();

                    } else {
                        alert("Erro de Conexão, tente novamente mais tarde");
                    }



                });
            }
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro na tentativa de exclusão: " + _err)

        }
    };


    async function handleClickDeletePagamento(row) {

        try {

            const confirmacao = window.confirm("Tem certeza que deseja excluir este pagamento?");

            if (confirmacao) {
                var id_user = Cookies.get('id_usuario');

                const token = Cookies.get('token');

                const headers = {
                    'Authorization': 'Bearer ' + token
                }

                await api.delete("v1/protected/financeiro/lancamentos/pagamentos/excluir/" + row.id_pagamento + "/" + id_user, {
                    headers: headers
                }).then(function (response) {

                    const deletado = response.data;
                    if (deletado) {
                        alert("Pagamento Excluído!");
                        listarInformacoes();

                    } else {
                        alert("Erro de Conexão, tente novamente mais tarde");
                    }



                });
            }
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro na tentativa de exclusão: " + _err)

        }
    };


    const handleCancel = () => {
        setIsEditing(false);
        setNewRow(createNewRow());
    };



    const handleCancelUpdate = () => {
        setIsUpdate(false);
        setInUpdate([]);
    };

    const { idLancamento } = useParams();

    const [lancamento, setLancamento] = useState(null);

    const [tipo, setTipo] = useState(0);
    const [dataLancamento, setDataLancamento] = useState('');
    const [centroCusto, setCentroCusto] = useState(null);
    const [fornecedor, setFornecedor] = useState(null);
    const [conta, setConta] = useState(null);
     const [cliente, setCliente] = useState(null);

 
 
 
    const [observacao, setObservacao] = useState('');
    const [descricao, setDescricao] = useState('');
    const [identificacao, setIdentificacao] = useState('');
    const [parcelas, setParcelas] = useState([]);
    const [pagamentos, setPagamentos] = useState([]);
    const [atributos, setAtributos] = useState([]);



    const onDropArquivo1 = useCallback(async (acceptedFiles) => {
        // Valida o tipo de arquivo
        // Valida o tipo de arquivo

        console.log("Id parcela in OnDrop: " + inUpdate.id_parcela);


        try {
            const formData = new FormData();
            formData.append('arquivos', acceptedFiles[0]);
            formData.append('extensao', acceptedFiles[0].name.split('.').pop());

            const response = await api.post('/v1/protected/financeiro/lancamentos/parcelas/anexararquivo/' + inUpdate.id_parcela + '/' + idLancamento, formData);

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                console.log("arquivo foi enviado");
                setIsEditing(false);
                setNewRow(createNewRow());
                listarInformacoes();


            } else {
                // Lógica a ser executada caso ocorra algum erro durante o salvamento
                console.log("Erro no cadastro_salvo");

            }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");
        }
    }, [inUpdate, idLancamento, setIsEditing, setNewRow]);



    const { getRootProps: getRootArquivoProps1, getInputProps: getInputArquivoProps1 } = useDropzone({
        onDrop: onDropArquivo1,
        multiple: false, // Apenas um arquivo pode ser selecionado
        //accept: '.pdf', // Restringe a aceitação apenas para arquivos .pdf

    });




    async function handleSaveRow() {
        try {

            var id_user = Cookies.get('id_usuario');

            const parsedDate = parse(newRow.data_vencimento, 'dd/MM/yyyy', new Date());
            if (isValid(parsedDate)) {

            } else {
                alert("A data é invalida!");
                return;
            }

            const dataFormatada = format(parse(newRow.data_vencimento, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');


            const cadastro = {

                id_lancamento: idLancamento,
                usuario_criador: { id_usuario: id_user, },
                valor: newRow.valor,
                data_vencimento: dataFormatada,


            };

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.post('/v1/protected/financeiro/lancamentos/parcelas/cadastrar', cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Parcela atualizada!");
                setIsEditing(false);
                setNewRow(createNewRow());
                listarInformacoes();

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente!");
        }

    };






    async function handleUpdateRow() {
        try {

            console.log("inUpdate recebido:", inUpdate);


            var id_user = Cookies.get('id_usuario');

            const parsedDate = parse(inUpdate.data_vencimento, 'dd/MM/yyyy', new Date());
            if (isValid(parsedDate)) {

            } else {
                alert("A data é invalida!");
                return;
            }

            const dataFormatada = format(parse(inUpdate.data_vencimento, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');


            const cadastro = {


                usuario_criador: { id_usuario: id_user, },
                valor: inUpdate.valor,
                data_vencimento: dataFormatada,
                observacao: inUpdate.observacao,
                descricao: inUpdate.descricao,
                identificador: inUpdate.identificador,
                metodo_pagamento: inUpdate.metodo_pagamento,



            };

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.put('/v1/protected/financeiro/lancamentos/parcelas/atualizar/' + inUpdate.id_parcela + '/' + idLancamento, cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Parcela Atualizada!");
                setIsUpdate(false);
                setInUpdate([]);

                listarInformacoes();

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente!");
        }






    };

   
  



    const handleChangeTipo = (event) => {
        setTipo(event.target.value);
    };


    const [columnsParcelas, setColumnsParcelas] = useState([]);
    const [columnsPagamentos, setColumnsPagamentos] = useState([]);



    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }
            await api.get("v1/protected/financeiro/metodospagamento/listartodos", {
                headers: headers
            }).then(function (response) {


                setMetodosPagamento(response.data)


            });

            api.get("/v1/protected/financeiro/lancamentos/listarporid/" + idLancamento, {
                headers: headers
            }).then(function (response) {

                setLancamento(response.data);
                const somaParcelas = response.data.parcelas.reduce((total, parcela) => total + parcela.valor, 0);

 
                const somaPagamentos = response.data.pagamentos.reduce((total, pagamento) => total + pagamento.valor, 0);

 

                setObjetoGerenciado(response.data);

                const parcelasOrdenadas = response.data.parcelas.sort((a, b) => a.id_parcela - b.id_parcela);
                setParcelas(parcelasOrdenadas);

                const pagamentosOrdenados = response.data.pagamentos.sort((a, b) => a.id_pagamento - b.id_pagamento);
                setPagamentos(pagamentosOrdenados);

                const atributosOrdenados = response.data.atributos.sort((a, b) => a.id_atributo - b.id_atributo);
                setAtributos(atributosOrdenados);

                setTipo(response.data.tipo);
                setDataLancamento(moment(response.data.data_lancamento).format('DD/MM/YYYY'));
                setCentroCusto(response.data.centro_custo);
                setFornecedor(response.data.fornecedor);
                setConta(response.data.conta);
                setCliente(response.data.cliente);

                setObservacao(response.data.observacao);
                setIdentificacao(response.data.identificacao);
                setDescricao(response.data.descricao);




                const columns = [

                    {
                        size: 50,
                        maxWidth: 50,
                        header: 'Info',
                        id: 1,
                        accessorFn: row => {
                            return {
                                observacao: row.observacao,
                                id_parcela: row.id_parcela,
                                identificador: row.identificador,
                                descricao: row.descricao,
                             };
                        },
                        Cell: ({ renderedCellValue }) => {
                            return (
                                <Tooltip
                                    title={
                                        <div
                                            style={{
                                                backgroundColor: 'white',
                                                padding: 10,
                                                color: 'black',
                                                fontSize: '14px',
                                                minHeight: '50px',
                                                minWidth: '420px',
                                                border: '2px solid #000',
                                                borderRadius: '8px',
                                                boxShadow: '0px 4px 10px rgba(0,0,0,0.15)',
                                            }}
                                        >
                                            <Grid container spacing={2}>

                                                <Grid item xs={12}>
                                                    <TextField
                                                        name="identificador"
                                                        label="🔑 Identificador"
                                                        id="identificador"
                                                        value={renderedCellValue.identificador}
                                                        fullWidth
                                                        multiline
                                                        minRows={2}
                                                        InputLabelProps={{
                                                            style: { fontWeight: 'bold', color: '#1976d2' }
                                                        }}
                                                        InputProps={{
                                                            readOnly: true,
                                                            style: { fontSize: '15px', fontStyle: 'italic', color: '#444' }
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <TextField
                                                        name="descricao"
                                                        label="📝 Descrição"
                                                        id="descricao"
                                                        value={renderedCellValue.descricao}
                                                        fullWidth
                                                        multiline
                                                        minRows={2}
                                                        InputLabelProps={{
                                                            style: { fontWeight: 'bold', color: '#1976d2' }
                                                        }}
                                                        InputProps={{
                                                            readOnly: true,
                                                            style: { fontSize: '15px', fontStyle: 'italic', color: '#444' }
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <TextField
                                                        name="observacao"
                                                        label="💡 Observações"
                                                        id="observacao"
                                                        value={renderedCellValue.observacao}
                                                        fullWidth
                                                        multiline
                                                        minRows={2}
                                                        InputLabelProps={{
                                                            style: { fontWeight: 'bold', color: '#1976d2' }
                                                        }}
                                                        InputProps={{
                                                            readOnly: true,
                                                            style: { fontSize: '15px', fontStyle: 'italic', color: '#444' }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                    }
                                    placement="right"
                                    arrow
                                    PopperProps={{
                                        style: { backgroundColor: 'transparent', zIndex: 1000 },
                                    }}
                                >
                                    <span style={{ fontWeight: 'bold', fontSize: '15px', color: '#1976d2' }}>
                                        📌 {renderedCellValue.id_parcela}
                                    </span>
                                </Tooltip>


                            );
                        },
                    },


                    {
                        id: 2,
                        header: 'Arquivo',
                        size: 50,
                        Cell: ({ row }) => {
                            return (
                                <div >
                                    {
                                        row.original.caminho_arquivo ? (
                                            <div
                                                onClick={() => {
                                                    baixarAnexo(row.original);
                                                }}
                                                style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '30px', height: '30px' }}
                                            >
                                                {/* Verifica a extensão do arquivo e exibe a miniatura ou o ícone correspondente */}
                                                {row.original.caminho_arquivo.toLowerCase().endsWith('.pdf') ? (
                                                    <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf} />
                                                ) : (row.original.caminho_arquivo.toLowerCase().endsWith('.doc') ||
                                                    row.original.caminho_arquivo.toLowerCase().endsWith('.docx') ||
                                                    row.original.caminho_arquivo.toLowerCase().endsWith('.xls') ||
                                                    row.original.caminho_arquivo.toLowerCase().endsWith('.xlsx') ||
                                                    row.original.caminho_arquivo.toLowerCase().endsWith('.ppt') ||
                                                    row.original.caminho_arquivo.toLowerCase().endsWith('.pptx')) ? (
                                                    <img alt={'office'} style={{ textAlign: 'center' }} src={office} />
                                                ) : (
                                                    <img alt={'comprovante'} style={{ textAlign: 'center' }} src={comprovante} />
                                                )}

                                            </div>
                                        ) : (
                                            <div >

                                            </div>
                                        )
                                    }
                                </div>
                            )

                        },
                    },


                    {
                        id: 3,
                        header: 'Data',
                        size: 100,
                        accessorKey: 'data_criacao',
                        Cell: ({ cell }) => {
                            return (
                                <span style={{ maxWidth: '100px' }}>
                                    {moment(cell.getValue()).format('DD/MM/YYYY')}
                                </span>
                            );
                        }
                    },


                    {


                        id: 4,
                        accessorKey: 'valor',
                        header: 'Valor Total',
                        size: 120,
                        Cell: ({ cell }) => {

                            return (
                                <span style={{ maxWidth: '120px' }}>
                                    {currencyFormatter.format(cell.getValue())}
                                </span>
                            );
                        },
                        Footer: () => (
                            <Stack style={{ color: 'black', backgroundColor: 'white', fontWeight: 'initial', fontSize: 16 }}>
                                <Box>
                                    {
                                        currencyFormatter.format(somaParcelas)
                                    }
                                </Box>
                            </Stack>
                        ),
                    },

                    {
                        id: 5,
                        accessorKey: 'data_vencimento',
                        header: 'Vencimento',

                        size: 100,
                        maxWidth: 100,
                        Cell: ({ cell }) => {
                            const value = cell.getValue();
                            const isFormatted = moment(value, 'DD/MM/YYYY', true).isValid();

                            return (
                                <span style={{ maxWidth: '100px' }}>
                                    {isFormatted ? value : moment(value).format('DD/MM/YYYY')}
                                </span>
                            );
                        }
                    },



                    {
                        id: 6,
                        header: 'Status',
                        size: 100,
                        accessorKey: 'status',
                        Cell: ({ renderedCellValue }) => {

                            return (
                                <span style={{ maxWidth: '100px' }} >{renderedCellValue === 0 ? "Há Pagar" : "Pago"}</span>
                            );
                        }
                    },

                ];

                setColumnsParcelas(columns);




                const columnsDePagamentos = [

                    {
                        size: 60,
                        maxWidth: 60,
                        header: 'Info',
                        accessorFn: row => {
                            return {
                                observacao: row.observacao,
                                id_pagamento: row.id_pagamento,
                                identificador: row.identificador,
                                descricao: row.descricao,
 
                            };
                        },
                        Cell: ({ renderedCellValue }) => {
                            return (
                                <Tooltip
                                    title={
                                        <Paper
                                            elevation={3}
                                            sx={{
                                                p: 2,
                                                backgroundColor: "white",
                                                color: "black",
                                                minWidth: 350,
                                                maxWidth: 450,
                                                borderRadius: 2,
                                                border: "1px solid #ddd",
                                            }}
                                        >
                                            <Grid container spacing={2}>
                                                {/* Identificador */}
                                                <Grid item xs={12}>
                                                    <Typography
                                                        variant="subtitle2"
                                                        color="textSecondary"
                                                        gutterBottom
                                                    >
                                                        Identificador
                                                    </Typography>
                                                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                        {renderedCellValue.identificador || "-"}
                                                    </Typography>
                                                </Grid>

                                                {/* Descrição */}
                                                <Grid item xs={12}>
                                                    <Typography
                                                        variant="subtitle2"
                                                        color="textSecondary"
                                                        gutterBottom
                                                    >
                                                        Descrição
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {renderedCellValue.descricao || "-"}
                                                    </Typography>
                                                </Grid>

                                                {/* Observações */}
                                                <Grid item xs={12}>
                                                    <Typography
                                                        variant="subtitle2"
                                                        color="textSecondary"
                                                        gutterBottom
                                                    >
                                                        Observações
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {renderedCellValue.observacao || "-"}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    }
                                    placement="right"
                                    arrow
                                    PopperProps={{
                                        sx: { zIndex: 1300 },
                                    }}
                                >
                                    <span style={{ cursor: "pointer", fontWeight: "bold", color: "#1976d2" }}>
                                        {renderedCellValue.id_pagamento}
                                    </span>
                                </Tooltip>

                            );
                        },
                    },

                    {
                        header: 'Data do Pagamento',
                        size: 120,
                        accessorKey: 'data_pagamento',
                        Cell: ({ row }) => {
                            return (
                                <span style={{ maxWidth: '120px' }}>
                                    {moment(row.original.data_pagamento).format('DD/MM/YYYY')} {row.original.hora_pagamento}
                                </span>
                            );
                        }
                    },

                    {
                        header: 'Arquivo',
                        size: 50,
                        Cell: ({ row }) => {
                            return (
                                <div >
                                    {
                                        row.original.caminho_arquivo ? (
                                            <div
                                                onClick={() => {
                                                    baixarAnexo(row.original);
                                                }}
                                                style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '30px', height: '30px' }}
                                            >
                                                {/* Verifica a extensão do arquivo e exibe a miniatura ou o ícone correspondente */}
                                                {row.original.caminho_arquivo.toLowerCase().endsWith('.pdf') ? (
                                                    <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf} />
                                                ) : (row.original.caminho_arquivo.toLowerCase().endsWith('.doc') ||
                                                    row.original.caminho_arquivo.toLowerCase().endsWith('.docx') ||
                                                    row.original.caminho_arquivo.toLowerCase().endsWith('.xls') ||
                                                    row.original.caminho_arquivo.toLowerCase().endsWith('.xlsx') ||
                                                    row.original.caminho_arquivo.toLowerCase().endsWith('.ppt') ||
                                                    row.original.caminho_arquivo.toLowerCase().endsWith('.pptx')) ? (
                                                    <img alt={'office'} style={{ textAlign: 'center' }} src={office} />
                                                ) : (
                                                    <img alt={'comprovante'} style={{ textAlign: 'center' }} src={comprovante} />
                                                )}

                                            </div>
                                        ) : (
                                            <div >

                                            </div>
                                        )
                                    }
                                </div>
                            )

                        },
                    },


                    {
                        header: 'Metodo',
                        size: 100,
                        accessorKey: 'metodo_pagamento',
                        Cell: ({ cell }) => {
                            return (
                                <span style={{ maxWidth: '100px' }}>
                                    {cell.getValue().nome}
                                </span>
                            );
                        }
                    },

                    {


                        accessorKey: 'valor',
                        header: 'Valor Total',
                        size: 120,
                        Cell: ({ cell }) => {

                            return (
                                <span style={{ maxWidth: '120px' }}>
                                    {currencyFormatter.format(cell.getValue())}
                                </span>
                            );
                        },
                        Footer: () => (
                            <Stack style={{ color: 'black', backgroundColor: 'white', fontWeight: 'initial', fontSize: 16 }}>
                                <Box>
                                    {
                                        currencyFormatter.format(somaPagamentos)
                                    }
                                </Box>
                            </Stack>
                        ),
                    },

                    {
                        header: 'Transação',
                        size: 120,

                        Cell: ({ row }) => {

                            let texto_pagador = "";
                            const tipo_pagador = row.original.tipo_pagador;
                            if (tipo_pagador === 0) {
                                //cliente
                                texto_pagador = returnDescricaoCliente(row.original.cliente_pagador);
                            } else if (tipo_pagador === 1) {
                                //ib
                                texto_pagador = returnDescricaoIb(row.original.instituicao_bancaria_pagador);
                            } else if (tipo_pagador === 2) {
                                //fornecedor
                                texto_pagador = returnDescricaoFornecedor(row.original.fornecedor_pagador);
                            }


                            let texto_recebedor = "";
                            const tipo_recebedor = row.original.tipo_recebedor;
                            if (tipo_recebedor === 0) {
                                //cliente
                                texto_recebedor = returnDescricaoCliente(row.original.cliente_recebedor);
                            } else if (tipo_recebedor === 1) {
                                //ib
                                texto_recebedor = returnDescricaoIb(row.original.instituicao_bancaria_recebedor);
                            } else if (tipo_recebedor === 2) {
                                //fornecedor
                                texto_recebedor = returnDescricaoFornecedor(row.original.fornecedor_recebedor);
                            }

                            let texto_origem = "";
                            if (row.original.natureza_pagamento === 0) {
                                texto_origem = "Débito";
                            } else if (row.original.natureza_pagamento === 1) {
                                texto_origem = "Crédito";
                            }

                            return (
                                <Box>
                                    <Tooltip
                                        title={
                                            <div
                                                style={{ minWidth: '150px', backgroundColor: 'white', padding: 10 }}
                                            >
                                                <span style={{ fontSize: 16, fontWeight: 'bold', color: 'black', whiteSpace: 'pre-wrap' }} >{"Pagador:"}</span>
                                                <br></br>
                                                <span style={{ fontSize: 14, color: 'black', whiteSpace: 'pre-wrap' }} >{texto_pagador}</span>
                                                <br></br>
                                                <span style={{ fontSize: 16, fontWeight: 'bold', color: 'black', whiteSpace: 'pre-wrap' }} >{"Origem do Pagamento:"}</span>
                                                <br></br>
                                                <span style={{ fontSize: 14, color: 'black', whiteSpace: 'pre-wrap' }} >{texto_origem}</span>
                                                <br></br>
                                                <span style={{ fontSize: 16, fontWeight: 'bold', color: 'black', whiteSpace: 'pre-wrap' }} >{"Recebedor:"}</span>
                                                <br></br>
                                                <span style={{ fontSize: 14, color: 'black', whiteSpace: 'pre-wrap' }} >{texto_recebedor}</span>
                                                <br></br>
                                                <span style={{ fontSize: 16, fontWeight: 'bold', color: 'black', whiteSpace: 'pre-wrap' }} >{"Status:"}</span>
                                                <br></br>
                                                <span style={{ fontSize: 14, color: 'black', whiteSpace: 'pre-wrap' }} >{row.original.status === 0 ? 'Há Concluir' : "Concluído"}</span>

                                            </div>
                                        }
                                        placement="right"
                                        arrow
                                        sx={{
                                            '& .MuiTooltip-popper': { // Target the popper element of the tooltip
                                                backgroundColor: 'white',
                                            },
                                        }}                                    >
                                        <span style={{ fontSize: 12, color: 'black', whiteSpace: 'nowrap' }}>{texto_pagador}</span>
                                    </Tooltip>
                                </Box>
                            );
                        }
                    },






                ];

                setColumnsPagamentos(columnsDePagamentos);




                setLoading(false);



            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }



 


    useEffect(() => {
         listarInformacoes();


    }, []);




    async function baixarAnexo(row) {
        try {
            const token = Cookies.get('token');
            const headers = {
                'Authorization': 'Bearer ' + token
            }

            const response = await api.post("/v1/protected/financeiro/lancamentos/baixaranexo", { caminho: encodeURIComponent(row.caminho_arquivo) }, {
                headers: headers,
                responseType: 'arraybuffer',  // Indica que a resposta é um array de bytes
            });

            const extensao = row.caminho_arquivo.split('.').pop().toLowerCase(); // Obtém a última parte do caminho após o último ponto e converte para minúsculas

            // Determina o tipo de mídia com base na extensão do arquivo
            let mediaType = 'application/octet-stream'; // Define um tipo padrão
            switch (extensao) {
                case 'pdf':
                    mediaType = 'application/pdf';
                    break;
                case 'doc':
                    mediaType = 'application/msword';
                    break;
                case 'docx':
                    mediaType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                    break;
                case 'xls':
                    mediaType = 'application/vnd.ms-excel';
                    break;
                case 'xlsx':
                    mediaType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    break;
                // Adicione outros tipos de arquivo conforme necessário
            }

            const blob = new Blob([response.data], { type: mediaType });

            // Cria uma URL do blob
            const blobUrl = URL.createObjectURL(blob);

            // Obtém o nome do arquivo a partir do caminho
            const nomeArquivo = row.caminho_arquivo.split('/').pop(); // Obtém a última parte do caminho após a última barra

            if (extensao === 'pdf') {
                // Abre o PDF em uma nova aba
                window.open(blobUrl, '_blank');
            } else {
                // Cria um link <a> temporário para download
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = nomeArquivo; // Define o nome do arquivo a ser baixado
                link.click(); // Simula um clique no link para iniciar o download
            }
        } catch (error) {
            // Trate os erros conforme necessário
            console.log("Erro ao baixar o arquivo: " + error);
        }
    }

 
    

    function returnDescricaoCentroCusto(cc) {
        var texto = cc.nome;
        return texto;
    }

    function returnDescricaoConta(conta) {
        var texto = conta.grupo_contas.nome + "\n" + conta.nome + "\nDescrição: " + conta.descricao;
        return texto;
    }

    function returnDescricaoIb(ib) {
        try {
            if (!ib || typeof ib !== "object") {
                throw new Error("Objeto inválido ou não fornecido");
            }

            // Cada campo é verificado individualmente
            const banco = (() => {
                try {
                    return ib.banco ?? "Não informado";
                } catch {
                    return "Erro ao acessar banco";
                }
            })();

            const agencia = (() => {
                try {
                    return ib.agencia ?? "Não informada";
                } catch {
                    return "Erro ao acessar agência";
                }
            })();

            const conta = (() => {
                try {
                    return ib.conta ?? "Não informada";
                } catch {
                    return "Erro ao acessar conta";
                }
            })();

            const descricao = (() => {
                try {
                    return ib.descricao ?? "Sem descrição";
                } catch {
                    return "Erro ao acessar descrição";
                }
            })();

            // Monta o texto final
            const texto =
                "Banco: " + banco +
                "\nAgência: " + agencia +
                "\nConta: " + conta +
                "\nDescrição: " + descricao;

            return texto;

        } catch (error) {
            console.error("Erro em returnDescricaoIb:", error.message);
            return "Erro ao gerar descrição dos dados bancários.";
        }
    }



    function returnDescricaoBanco(ib) {

        var texto = "Identificação: " + ib.identificacao +
            "\nTitular: " + ib.titular +
            "\nBanco: " + ib.banco +
            "\nAgência: " + ib.agencia +
            "\nConta: " + ib.conta +
            "\nDescrição: " + ib.descricao +
            "\nPix: " + ib.tipo_chave_1 + "=" + ib.chave_1;
        return texto;


    }




    async function baixarArquivo(caminho) {
        try {
            const token = Cookies.get('token');
            const headers = {
                'Authorization': 'Bearer ' + token
            }

            const response = await api.post("/v1/protected/ordensdecompras/baixarPdf", { caminho: encodeURIComponent(caminho) }, {
                headers: headers,
                responseType: 'arraybuffer',  // Indica que a resposta é um array de bytes
            });

            // Cria um blob com os dados recebidos
            const blob = new Blob([response.data], { type: 'application/pdf' });

            // Cria uma URL do blob
            const blobUrl = URL.createObjectURL(blob);

            // Abre uma nova guia com o arquivo PDF
            window.open(blobUrl, '_blank');
        } catch (error) {
            // Trate os erros conforme necessário
            console.log("Erro ao baixar o arquivo: " + error);
        }
    }




    function returnDescricaoFornecedor(fornecedor) {

 
        var valor = fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj;

        var nome = fornecedor.tipo_fornecedor === 0 ? (fornecedor.nome + " " + fornecedor.sobrenome) :
            (fornecedor.nome_fantasia);

        var endereco = fornecedor.logradouro + ", nº " + fornecedor.numero + ", " + fornecedor.bairro + ", " + fornecedor.cidade + " " + fornecedor.estado + " CEP: " + fornecedor.cep;


        var texto = nome + " | " + valor + "\n Endereço: " + endereco;
        return texto;
    }


    function returnDescricaoCliente(cliente) {

        var identificacao = cliente.tipo_cliente === 0 ? "CPF " : "CNPJ"

        var valor = cliente.tipo_cliente === 0 ? cliente.cpf : cliente.cnpj;

        var nome = cliente.tipo_cliente === 0 ? (cliente.nome + " " + cliente.sobrenome) :
            (cliente.nome_fantasia);

        var endereco = cliente.logradouro + ", nº " + cliente.numero + ", " + cliente.bairro + ", " + cliente.cidade + " " + cliente.estado + " CEP: " + cliente.cep;


        var texto = "ID: " + cliente.id_cliente + " " + identificacao + " " + valor + " " + nome + "\n Endereço: " + endereco;
        return texto;
    }



    function returnDescricaoMetodoPagamento(metodo) {
        var texto = "Nome: " + metodo.nome +
            " | Codigo: " + metodo.codigo + " | Sigla: " + metodo.sigla;
        return texto;
    }

    const columnsNotasFiscais = useMemo(
        () => [
            {
                accessorKey: 'id_nota_fiscal',
                header: 'ID',
                size: 50,
            },
            {
                accessorKey: 'numero',
                header: 'Número',
                size: 150,
            },
            {
                accessorKey: 'valor_total',
                header: 'Valor Total',
                size: 150,
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    return value != null
                        ? value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                        : '-';
                },
                Footer: ({ table }) => {
                    const total = table.getRowModel().rows.reduce((acc, row) => {
                        const val = row.original.valor_total ?? 0;
                        return acc + val;
                    }, 0);
                    return total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                },
            },
            {
                accessorKey: 'data_nf',
                header: 'Data',
                size: 150,
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    return value ? moment(value).format('DD/MM/YYYY') : '-';
                },
            },
        ],
        [],
    );

    return (
        <div>

            <NavegadorGestao
                Financas={true}
                Lancamentos={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />




            <div style={{ paddingTop: 5 }}>
                {loading ?
                    <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                    </Skeleton>
                    :

                    <React.Fragment >

                        <Grid
                            item xs={12}
                            container
                            direction="row"
                            alignItems="center"
                            justifyContent={"center"}
                        >

                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                align="flex-start"
                                item xs={12}
                                style={{ padding: 5 }}
                            >

                                <a href="/gestao/financas/lancamento/listar" style={{ fontSize: 14, color: 'black', marginRight: '5px' }}>{"< Lançamentos"}</a>
                                <a
                                    style={{ fontSize: 14, color: 'black', marginRight: '5px' }}
                                >
                                    {"< " + (objetoGerenciado.tipo === 0 ? "DESPESA" : "RECEITA") + " nº " + objetoGerenciado.identificador}
                                </a>
                            </Grid>

                            <Grid
                                item xs={12}
                                container
                                direction="row"
                                alignItems="center"
                                justifyContent={"center"}
                            >


                                <Box style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}>
                                    <AppBar position="static" >

                                        <Tabs
                                            value={value}
                                            onChange={handleChange}
                                            indicatorColor="secondary"
                                            textColor="inherit"
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            aria-label="scrollable auto tabs example"


                                        >
                                            <Tab label="Especificações" style={{ backgroundColor: '#1C1C1C' }} />
                                            <Tab label="Finanças" style={{ backgroundColor: 'green' }} />

                                        </Tabs>
                                    </AppBar>

                                </Box>
                            </Grid>

                            <Grid
                                item xs={12}
                                container
                                direction="row"
                                alignItems="center"
                                justifyContent={"center"}
                            >

                                <SwipeableViews
                                    index={value}
                                    onChangeIndex={handleChangeIndex}
                                    style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                                >
                                    <Grid value={value} index={0}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                                    >
                                        <Grid
                                            item xs={12}
                                            alignItems="flex-start"
                                            justifyContent="flex-start"
                                            style={{ padding: 10 }}
                                            container  >



                                            <Grid
                                                item xs={12}
                                                alignItems="flex-end"
                                                justifyContent="flex-end"
                                                style={{ padding: 2 }}
                                                container  >
                                                <Button variant="contained" color="primary"
                                                    onClick={(event) => handleClickAtualizarLancamento()}
                                                >
                                                    Atualizar
                                                </Button>

                                            </Grid>




                                            <Grid item xs={3} style={{ padding: 2 }}>
                                                <Card style={{ marginBottom: '10px', borderRadius: '8px', border: '1px solid gray' }}>
                                                    <CardContent>
                                                        <Grid
                                                            item xs={12}
                                                            alignItems="flex-start"
                                                            justifyContent="flex-start"
                                                            style={{ padding: 2 }}
                                                            container  >


                                                            <Grid
                                                                item xs={12}
                                                                alignItems="flex-start"
                                                                justifyContent="flex-start"
                                                                style={{ padding: 10 }}
                                                                container
                                                            >
                                                                <Grid item xs={12}
                                                                    container
                                                                    alignItems="center"
                                                                    justifyContent="center"
                                                                >
                                                                    <Grid item xs={12}>
                                                                        <FormControl fullWidth>
                                                                            <InputLabel id="tipo_notificacao_registro-label">Tipo do Lançamento</InputLabel>
                                                                            <Select
                                                                                labelId="tipo_notificacao_registro-label"
                                                                                id="area-tipo_registro"
                                                                                value={tipo}
                                                                                onChange={handleChangeTipo}
                                                                                label="Tipo do Lançamento"
                                                                            >
                                                                                <MenuItem value={0}>Despesa</MenuItem>
                                                                                <MenuItem value={1}>Receita</MenuItem>

                                                                            </Select>
                                                                        </FormControl>
                                                                    </Grid>
                                                                </Grid>


                                                            </Grid>

                                                            <Grid
                                                                item xs={12}
                                                                alignItems="flex-start"
                                                                justifyContent="flex-start"
                                                                style={{ padding: 10 }}
                                                                container
                                                            >


                                                                <Typography variant="body1">
                                                                    <strong>Status:</strong> {objetoGerenciado.status === 0 ? 'Não Pago' : 'Pago'}
                                                                </Typography>

                                                            </Grid>


                                                            <Grid
                                                                item xs={12}
                                                                alignItems="flex-start"
                                                                justifyContent="flex-start"
                                                                style={{ padding: 10 }}
                                                                container
                                                            >

                                                                <TextField
                                                                    variant="standard"
                                                                    name="dataLancamento"
                                                                    label="Data Lançamento"
                                                                    required
                                                                    id="dataLancamento"
                                                                    value={dataLancamento}
                                                                    onChange={(e) => setDataLancamento(e.target.value)}
                                                                    fullWidth
                                                                />

                                                            </Grid>
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>


                                            {tipo === 0 &&

                                                <Grid item xs={6} style={{ padding: 2 }}>
                                                    <Card style={{ marginBottom: '10px', borderRadius: '8px', border: '1px solid gray' }}>
                                                        <CardContent>


                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="center"
                                                                align="center"
                                                                item xs={12}
                                                            >
                                                                <Grid
                                                                    container
                                                                    direction="column"
                                                                    justifyContent="center"
                                                                    align="center"
                                                                    item xs={12}
                                                                    style={{ padding: 10 }}
                                                                >

                                                                    <Autocomplete
                                                                        id="select-centro-custo"
                                                                        options={[]}
                                                                        getOptionLabel={(centroCusto) => returnDescricaoCentroCusto(centroCusto).replace(/<br \/>/g, '\n')}
                                                                        value={centroCusto}
                                                                        onChange={(e, v) => setCentroCusto(v)}
                                                                        filterOptions={(options, { inputValue }) => {
                                                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                            return options.filter((centroCusto) => {
                                                                                const cotacaoText = returnDescricaoCentroCusto(centroCusto).toLowerCase();
                                                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                            });
                                                                        }}
                                                                        renderInput={(params) => (
                                                                            <TextField {...params} label="Pagador: Centro de Custo" multiline minRows={2} fullWidth />
                                                                        )}
                                                                        renderOption={(option) => (
                                                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoCentroCusto(option) }} />
                                                                        )}
                                                                    />
                                                                </Grid>
                                                            </Grid>


                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="center"
                                                                alignItems="center"
                                                                item
                                                                xs={12}
                                                            >
                                                                <Grid
                                                                    item
                                                                    xs={8}
                                                                    style={{ padding: 10 }}
                                                                >
                                                                    <Autocomplete
                                                                        id="select-fornecedor_cotacao1"
                                                                        options={[]}
                                                                        getOptionLabel={(fornecedor) =>
                                                                            returnDescricaoFornecedor(fornecedor).replace(/<br \/>/g, "\n")
                                                                        }
                                                                        value={fornecedor}
                                                                        onChange={(e, v) => setFornecedor(v)}
                                                                        filterOptions={(options, { inputValue }) => {
                                                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                            return options.filter((fornecedor) => {
                                                                                const cotacaoText = returnDescricaoFornecedor(fornecedor).toLowerCase();
                                                                                return inputKeywords.every((keyword) =>
                                                                                    cotacaoText.includes(keyword)
                                                                                );
                                                                            });
                                                                        }}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                label="Recebedor: Fornecedor"
                                                                                multiline
                                                                                minRows={2}
                                                                                fullWidth
                                                                            />
                                                                        )}
                                                                        renderOption={(props, option) => (
                                                                            <li {...props}>
                                                                                <div
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: returnDescricaoFornecedor(option),
                                                                                    }}
                                                                                />
                                                                            </li>
                                                                        )}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={2} style={{ textAlign: "center" }}>
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        startIcon={<GroupIcon />}
                                                                        onClick={() =>
                                                                            window.open(
                                                                                "/gestao/operacional/almoxarifado/fornecedores/gerenciarfornecedor/" +
                                                                                fornecedor?.id_fornecedor,
                                                                                "_blank",
                                                                                "noopener,noreferrer"
                                                                            )
                                                                        }
                                                                    >
                                                                        Fornecedor
                                                                    </Button>
                                                                </Grid>
                                                            </Grid>
                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            }

                                            {tipo === 1 &&
                                                <Grid item xs={5} style={{ padding: 2 }}>
                                                    <Card style={{ marginBottom: '10px', borderRadius: '8px', border: '1px solid gray' }}>
                                                        <CardContent>


                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="center"
                                                                align="center"
                                                                item xs={12}
                                                            >
                                                                <Grid
                                                                    container
                                                                    direction="column"
                                                                    justifyContent="center"
                                                                    align="center"
                                                                    item xs={12}
                                                                    style={{ padding: 10 }}
                                                                >

                                                                    <Autocomplete
                                                                        id="select-fornecedor_cotacao1"
                                                                        options={[]}

                                                                        getOptionLabel={(cliente) => returnDescricaoCliente(cliente).replace(/<br \/>/g, '\n')}
                                                                        value={cliente}
                                                                        onChange={(e, v) => setCliente(v)}
                                                                        filterOptions={(options, { inputValue }) => {
                                                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                            return options.filter((cliente) => {
                                                                                const cotacaoText = returnDescricaoCliente(cliente).toLowerCase();
                                                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                            });
                                                                        }}
                                                                        renderInput={(params) => (
                                                                            <TextField {...params} label="Pagador: Cliente" multiline minRows={2} fullWidth />
                                                                        )}
                                                                        renderOption={(option) => (
                                                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoCliente(option) }} />
                                                                        )}
                                                                    />
                                                                </Grid>
                                                            </Grid>



                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="center"
                                                                align="center"
                                                                item xs={12}
                                                            >
                                                                <Grid
                                                                    container
                                                                    direction="column"
                                                                    justifyContent="center"
                                                                    align="center"
                                                                    item xs={12}
                                                                    style={{ padding: 10 }}
                                                                >

                                                                    <Autocomplete
                                                                        id="select-centro-custo"
                                                                        options={[]}
                                                                        getOptionLabel={(centroCusto) => returnDescricaoCentroCusto(centroCusto).replace(/<br \/>/g, '\n')}
                                                                        value={centroCusto}
                                                                        onChange={(e, v) => setCentroCusto(v)}
                                                                        filterOptions={(options, { inputValue }) => {
                                                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                            return options.filter((centroCusto) => {
                                                                                const cotacaoText = returnDescricaoCentroCusto(centroCusto).toLowerCase();
                                                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                            });
                                                                        }}
                                                                        renderInput={(params) => (
                                                                            <TextField {...params} label="Recebedor: Centro de Custo" multiline minRows={2} fullWidth />
                                                                        )}
                                                                        renderOption={(option) => (
                                                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoCentroCusto(option) }} />
                                                                        )}
                                                                    />
                                                                </Grid>
                                                            </Grid>



                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            }




                                            <Grid item xs={3} style={{ padding: 2 }}>
                                                <Card style={{ marginBottom: '10px', borderRadius: '8px', border: '1px solid gray' }}>
                                                    <CardContent>
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            justifyContent="center"
                                                            align="center"
                                                            item xs={12}
                                                        >
                                                            <Grid
                                                                container
                                                                direction="column"
                                                                justifyContent="center"
                                                                align="center"
                                                                item xs={12}
                                                                style={{ padding: 10 }}
                                                            >
                                                                <Autocomplete
                                                                    id="select-conta"
                                                                    options={[]}

                                                                    getOptionLabel={(conta) => returnDescricaoConta(conta).replace(/<br \/>/g, '\n')}
                                                                    value={conta}
                                                                    onChange={(e, v) => setFornecedor(v)}
                                                                    filterOptions={(options, { inputValue }) => {
                                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                        return options.filter((conta) => {
                                                                            const cotacaoText = returnDescricaoConta(conta).toLowerCase();
                                                                            return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                        });
                                                                    }}
                                                                    renderInput={(params) => (
                                                                        <TextField {...params} label="Conta" multiline minRows={2} fullWidth />
                                                                    )}
                                                                    renderOption={(option) => (
                                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoConta(option) }} />
                                                                    )}
                                                                />
                                                            </Grid>
                                                        </Grid>


                                                        <Grid
                                                            item xs={12}
                                                            alignItems="flex-start"
                                                            justifyContent="flex-start"
                                                            style={{ padding: 15 }}
                                                            container
                                                        >

                                                            <Typography variant="body1" style={{ fontSize: 18 }}>
                                                                Valor:<strong> {currencyFormatter.format(objetoGerenciado.valor)}</strong>
                                                            </Typography>

                                                        </Grid>

                                                        {objetoGerenciado.pre_cotacao && (
                                                            <Tooltip
                                                                title="Clique para ver dados de pagamento"
                                                                placement="left"
                                                                arrow
                                                            >
                                                                <IconButton
                                                                    size="small"
                                                                    style={{ marginLeft: 8 }}
                                                                    onClick={() => setOpenDadosPagamento(true)}
                                                                >
                                                                    <PaymentIcon color="primary" fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )}

                                                    </CardContent>
                                                </Card>
                                            </Grid>


                                        </Grid>




                                        <Grid
                                            item xs={12}
                                            alignItems="center"
                                            justifyContent="center"
                                            style={{ padding: 2 }}
                                            container
                                        >


                                            <Grid
                                                item xs={6}
                                                alignItems="center"
                                                justifyContent="center"
                                                style={{ padding: 2 }}
                                                container
                                            >

                                                <Grid
                                                    item xs={6}
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    container
                                                >
                                                    <TextField
                                                        variant="standard"
                                                        name="identificacao"
                                                        label="Identificação"
                                                        required
                                                        id="identificacao"
                                                        value={identificacao}
                                                        fullWidth
                                                    />

                                                </Grid>
                                                <Grid
                                                    item xs={1}
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    container
                                                >
                                                    {objetoGerenciado.pre_cotacao && (
                                                        <Tooltip title="Clique para Abrir a Pré-Cotação" arrow>
                                                            <IconButton
                                                                onClick={() => {
                                                                    const link =
                                                                        "/gestao/administracao/ordensdecompras/editar/" +
                                                                        objetoGerenciado.id_ordem_compra +
                                                                        "/editarcotacao/" +
                                                                        objetoGerenciado.pre_cotacao.id_pre_cotacao;
                                                                    window.open(link, "_blank", "noopener,noreferrer");
                                                                }}
                                                            >
                                                                <RequestQuoteIcon style={{ color: 'black' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                </Grid>
                                                <Grid
                                                    item xs={2}
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    container
                                                >
                                                    {objetoGerenciado.pre_cotacao && (
                                                        <Tooltip title="Clique para acessar a Ordem de Compra autorizada" arrow>
                                                            <div
                                                                //  onClick={() => {
                                                                //     const link = objetoGerenciado.pre_cotacao.caminho_arquivo.replaceAll(
                                                                //       "/home/wwgrup/ordensdecompra/",
                                                                //     "https://gruporosinetos.com/ocmidias/"
                                                                // );
                                                                // window.open(link, "_blank", "noopener,noreferrer");
                                                                //}}
                                                                onClick={() => {
                                                                    baixarArquivo(objetoGerenciado.pre_cotacao.caminho_arquivo);
                                                                }}
                                                                style={{
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    margin: 0,
                                                                    width: "40px",
                                                                    height: "40px",
                                                                }}
                                                            >
                                                                <img
                                                                    alt="miniatura_pdf"
                                                                    style={{ textAlign: "center" }}
                                                                    src={miniatura_pdf}
                                                                />
                                                            </div>
                                                        </Tooltip>
                                                    )}
                                                </Grid>



                                            </Grid>

                                            <Grid
                                                item xs={6}
                                                alignItems="center"
                                                justifyContent="center"
                                                style={{ padding: 2 }}
                                                container
                                            >

                                                <TextField
                                                    variant="standard"
                                                    name="descricao"
                                                    label="Descrição"
                                                    required
                                                    id="descricao"
                                                    value={descricao}
                                                    fullWidth
                                                    multiline
                                                    minRows={1}
                                                />
                                            </Grid>


                                        </Grid>

                                        <Grid
                                            container
                                            item
                                            xs={12}
                                            alignItems="center"
                                            justifyContent="center"
                                            style={{ padding: 10 }}
                                        >
                                            <Grid item xs={3} />

                                            <Grid item xs={3} style={{ textAlign: "center" }}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    startIcon={<WorkOutlineIcon />}
                                                    onClick={(e) => handleAbrirProjeto(objetoGerenciado.id_projeto)}
                                                    disabled={objetoGerenciado.id_projeto ? false : true}
                                                >
                                                    Projeto
                                                </Button>
                                            </Grid>

                                            <Grid item xs={3} style={{ textAlign: "center" }}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    startIcon={<ReceiptLongIcon />}
                                                    onClick={(e) => handleAbrirOrdemCompra(objetoGerenciado.id_ordem_compra)}
                                                    disabled={objetoGerenciado.id_ordem_compra ? false : true}

                                                >
                                                    Ordem de Compra
                                                </Button>
                                            </Grid>

                                            <Grid item xs={3} />
                                        </Grid>



                                        <Grid
                                            item xs={12}
                                            alignItems="flex-start"
                                            justifyContent="flex-start"
                                            style={{ padding: 10 }}
                                            container
                                        >
                                            <Grid
                                                item xs={12}
                                                alignItems="flex-start"
                                                justifyContent="flex-start"
                                                style={{ padding: 10 }}
                                                container
                                            >
                                                <TextField
                                                    variant="standard"
                                                    name="observacao"
                                                    label="Observações"
                                                    required
                                                    id="observacao"
                                                    value={observacao}
                                                    onChange={(e) => setObservacao(e.target.value)}
                                                    fullWidth
                                                    multiline
                                                    minRows={1}
                                                />
                                            </Grid>
                                        </Grid>


                                        <Grid
                                            item xs={12}
                                            alignItems="center"
                                            justifyContent="center"
                                            style={{ padding: 20 }}
                                            container
                                        >

                                            <Grid
                                                item xs={8}
                                                alignItems="flex-start"
                                                justifyContent="flex-start"
                                                style={{ padding: 3 }}
                                                container
                                            >
                                                <Typography variant="body1" style={{ fontSize: 24 }}>
                                                    <strong>Notas Fiscais</strong>
                                                </Typography>
                                            </Grid>
                                            <Grid
                                                item xs={3}
                                                alignItems="flex-start"
                                                justifyContent="flex-start"
                                                container
                                            >

                                                <IconButton
                                                    tyle={{ fontSize: 10 }}
                                                    color="primary" onClick={() => handleOpenCadastrarNF()}>
                                                    <AddIcon /> Nova Nota Fiscal
                                                </IconButton>
                                            </Grid>

                                            <Grid
                                                item xs={12}
                                                alignItems="center"
                                                justifyContent="center"
                                                style={{ padding: 5 }}
                                                container
                                            >
                                                <MaterialReactTable
                                                    columns={columnsNotasFiscais}
                                                    data={objetoGerenciado.notas_fiscais}
                                                    enableTopToolbar={false}
                                                    enableBottomToolbar={false}
                                                    enablePagination={false}
                                                    enableColumnFilters={false}
                                                    enableColumnActions={false}
                                                    sortable={false}
                                                    enableRowActions={true}
                                                    enableSorting={false}
                                                    enableRowSelection={false}
                                                    color={'black'}
                                                    paginationDisplayMode={'pages'}
                                                    getRowId={(row) => row.id_nota_fiscal}
                                                    initialState={{
                                                        pagination: { pageSize: 20, pageIndex: 0 },
                                                        showGlobalFilter: true,
                                                        color: 'black'
                                                    }}
                                                    muiTableContainerProps={{ sx: { maxHeight: "3000px", color: 'black' } }}
                                                    muiTableBodyRowProps={{
                                                        sx: {
                                                            height: 35,
                                                            color: 'black' // Define a cor do texto para preto
                                                        },
                                                    }}
                                                    enableColumnFilterModes={false}
                                                    enableExpandAll={true}
                                                    enableColumnPinning={true}
                                                    enableColumnResizing={true}
                                                    muiPaginationProps={{
                                                        rowsPerPageOptions: [20, 50, 100],
                                                        variant: 'outlined',
                                                    }}
                                                    enableFullScreenToggle={true}
                                                    muiTablePaperProps={({ table }) => ({
                                                        style: {
                                                            zIndex: table.getState().isFullScreen ? 1000 : undefined,
                                                            color: 'black',
                                                        },
                                                    })}
                                                    renderRowActionMenuItems={({ row, table }) => [

                                                        <Tooltip title="Deletar">
                                                            <IconButton size="small" color="error" onClick={() => handleClickDeleteNotaFiscal(row.original)}>
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    ]}

                                                />
                                            </Grid>



                                        </Grid>

                                    </Grid>



                                    <Grid value={value} index={1}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                                    >

                                       
                                        <Grid
                                            container
                                            direction="row"
                                            item
                                            xs={12}
                                            alignItems="center"
                                            justifyContent="center"
                                            style={{
                                                paddingTop: 10,
                                                backgroundColor: 'white',
                                                width: '100%',
                                            }}
                                        >
                                            <Grid
                                                item
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor:
                                                        objetoGerenciado.status === 1 ? '#e8f5e9' : '#ffebee',
                                                    borderRadius: '12px',
                                                    padding: '10px 20px',
                                                    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                                                    width: 'fit-content',
                                                }}
                                            >
                                                {objetoGerenciado.status === 1 ? (
                                                    <CheckCircleIcon
                                                        sx={{ color: '#2e7d32', marginRight: 1, fontSize: 28 }}
                                                    />
                                                ) : (
                                                    <CancelIcon
                                                        sx={{ color: '#d32f2f', marginRight: 1, fontSize: 28 }}
                                                    />
                                                )}
                                                <Typography
                                                    variant="h6"
                                                    sx={{
                                                        fontWeight: 'bold',
                                                        color: objetoGerenciado.status === 1 ? '#2e7d32' : '#d32f2f',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: 1,
                                                    }}
                                                >
                                                    {`Status: ${objetoGerenciado.status === 1 ? 'Pago' : 'Não Pago'}`}
                                                </Typography>
                                            </Grid>
                                        </Grid>


                                        <Grid
                                            container
                                            direction="row"
                                            item xs={12}
                                            alignItems="center"
                                            justifyContent="center"
                                            style={{ paddingTop: 20, backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                                            spacing={1}
                                        >
                                            <Grid
                                                container
                                                direction="row"
                                                item xs={6}
                                                alignItems="center"
                                                justifyContent="center"

                                                style={{
                                                    margin: 0,
                                                    border: '1px solid #000',// Cor azul escuro e borda pontilhada
                                                    borderRadius: 4, // Borda levemente arredondada
                                                    width: '100%',
                                                }}

                                            >






                                                {!isUpdate &&
                                                    <Grid
                                                        item xs={12}
                                                        alignItems="center"
                                                        justifyContent="space-between"
                                                        container
                                                    >

                                                        <Grid
                                                            item xs={6}
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            container
                                                        >

                                                            <Typography variant="body1" style={{ fontSize: 18 }}>
                                                                <strong>Parcelas</strong>
                                                            </Typography>




                                                        </Grid>

                                                        <Grid
                                                            item xs={2}
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            container
                                                        >

                                                            <IconButton color="primary" onClick={() => handleOpenGeradorParcelas()}>
                                                                <RequestQuoteIcon />
                                                            </IconButton>
                                                        </Grid>

                                                        <Grid
                                                            item xs={2}
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            container
                                                        >

                                                            <IconButton color="primary" onClick={() => handleAddRow()}>
                                                                <AddIcon />
                                                            </IconButton>
                                                        </Grid>




                                                    </Grid>
                                                }
                                                {!isUpdate && !isEditing &&
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        item xs={12}
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        style={{ width: '100%', margin: 0, padding: 0, color: 'black' }}
                                                    >

                                                        <MaterialReactTable
                                                            columns={columnsParcelas}
                                                            data={isEditing ? [...parcelas, newRow] : parcelas}
                                                            enableTopToolbar={false}
                                                            enableBottomToolbar={false}
                                                            enablePagination={false}
                                                            enableColumnFilters={false}
                                                            enableColumnActions={false}
                                                            sortable={false}
                                                            enableRowActions={true}
                                                            enableSorting={false}
                                                            enableRowSelection={false}
                                                            color={'black'}
                                                            paginationDisplayMode={'pages'}
                                                            getRowId={(row) => row.id_item_analise}
                                                            initialState={{
                                                                pagination: { pageSize: 20, pageIndex: 0 },
                                                                showGlobalFilter: true,
                                                                color: 'black'
                                                            }}
                                                            muiTableContainerProps={{ sx: { maxHeight: "3000px", color: 'black' } }}
                                                            muiTableBodyRowProps={{
                                                                sx: {
                                                                    height: 35,
                                                                    color: 'black' // Define a cor do texto para preto
                                                                },
                                                            }}
                                                            enableColumnFilterModes={false}
                                                            enableExpandAll={true}
                                                            enableColumnPinning={true}
                                                            enableColumnResizing={true}
                                                            muiPaginationProps={{
                                                                rowsPerPageOptions: [20, 50, 100],
                                                                variant: 'outlined',
                                                            }}
                                                            enableFullScreenToggle={true}
                                                            muiTablePaperProps={({ table }) => ({
                                                                style: {
                                                                    zIndex: table.getState().isFullScreen ? 1000 : undefined,
                                                                    color: 'black',
                                                                },
                                                            })}
                                                            renderRowActionMenuItems={({ row, table }) => [
                                                                < Tooltip title="Editar">
                                                                    <IconButton size="small" onClick={() => handleClickEditar(row.original)}>
                                                                        <EditIcon />
                                                                    </IconButton>
                                                                </Tooltip>,
                                                                <Tooltip title="Deletar">
                                                                    <IconButton size="small" color="error" onClick={() => handleClickDelete(row.original)}>
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            ]}



                                                        />

                                                    </Grid>
                                                }
                                                {isEditing && (
                                                    <Grid
                                                        item xs={12}
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        container
                                                        style={{ marginTop: 10 }}
                                                    >
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            container
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            spacing={2}
                                                            style={{ paddingTop: 5 }}
                                                        >
                                                            {Object.keys(newRow).map((key) => (
                                                                <TextField
                                                                    key={key}
                                                                    id={key}
                                                                    variant="standard"
                                                                    value={newRow[key] || ''}
                                                                    onChange={(e) => setNewRow({ ...newRow, [key]: e.target.value })}
                                                                    style={{ marginRight: 10 }}
                                                                    label={key === 'valor' ? "Valor" : "Data Vencimento"}


                                                                />
                                                            ))}
                                                        </Grid>



                                                        <Grid
                                                            item
                                                            xs={12}
                                                            container
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            spacing={2}
                                                            style={{ marginTop: 5 }}
                                                        >
                                                            <IconButton color="success" onClick={() => handleSaveRow()} >
                                                                <SaveIcon />
                                                            </IconButton>
                                                            <IconButton color="error" onClick={() => handleCancel()}>
                                                                <CancelIcon />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                )}


                                                {isUpdate && (
                                                    <Grid
                                                        item xs={12}
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        container
                                                        style={{ marginTop: 10 }}
                                                    >
                                                        <Grid
                                                            item
                                                            xs={6}
                                                            container
                                                            alignItems="center"
                                                            justifyContent="center"
                                                        >
                                                            <TextField
                                                                id="valor"
                                                                variant="standard"
                                                                value={inUpdate.valor}
                                                                onChange={(e) => {
                                                                    // Remove qualquer caractere que não seja dígito ou ponto
                                                                    const sanitized = e.target.value.replace(/[^0-9.]/g, '');
                                                                    setInUpdate({ ...inUpdate, valor: sanitized });
                                                                }}
                                                                label="Valor"

                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={6}
                                                            container
                                                            alignItems="center"
                                                            justifyContent="center"
                                                        >
                                                            <TextField
                                                                id="data_vencimento"
                                                                variant="standard"
                                                                value={inUpdate.data_vencimento}
                                                                onChange={(e) => setInUpdate({ ...inUpdate, "data_vencimento": e.target.value })}
                                                                label="Data Vencimento"

                                                            />
                                                        </Grid>

                                                        <Grid item xs={12}
                                                            container
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            style={{ marginTop: 10 }}
                                                        >

                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="center"
                                                                alignItems="center"
                                                                item xs={10}
                                                            >

                                                                <Autocomplete
                                                                    id="select-metodos-pagamento"
                                                                    options={metodosPagamento}
                                                                    fullWidth
                                                                    getOptionLabel={(metodo) => returnDescricaoMetodoPagamento(metodo).replace(/<br \/>/g, '\n')}
                                                                    value={inUpdate.metodo_pagamento}

                                                                    onChange={(e, value) => {
                                                                        setInUpdate({ ...inUpdate, "metodo_pagamento": value })

                                                                    }}

                                                                    autoSelect
                                                                    filterOptions={(options, { inputValue }) => {
                                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                        return options.filter((solicitante) => {
                                                                            const cotacaoText = returnDescricaoMetodoPagamento(solicitante).toLowerCase();
                                                                            return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                        });
                                                                    }}
                                                                    renderInput={(params) => (
                                                                        <TextField {...params} label=" Metodo de Pagamento " multiline minRows={1} />
                                                                    )}
                                                                    renderOption={(option) => (
                                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoMetodoPagamento(option).replace(/\n/g, '<br>') }} />
                                                                    )}

                                                                />
                                                            </Grid>



                                                        </Grid>

                                                        <Grid
                                                            item
                                                            xs={10}
                                                            container
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            style={{ marginTop: 5 }}
                                                        >
                                                            <TextField
                                                                id="identificador"
                                                                variant="standard"
                                                                value={inUpdate.identificador}
                                                                onChange={(e) => setInUpdate({ ...inUpdate, "identificador": e.target.value })}
                                                                label="Identificador"
                                                                multiline
                                                                minRows={2}
                                                                fullWidth

                                                            />
                                                        </Grid>


                                                        <Grid
                                                            item
                                                            xs={10}
                                                            container
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            style={{ marginTop: 5 }}
                                                        >
                                                            <TextField
                                                                id="descricao"
                                                                variant="standard"
                                                                value={inUpdate.descricao}
                                                                onChange={(e) => setInUpdate({ ...inUpdate, "descricao": e.target.value })}
                                                                label="Descrição"
                                                                multiline
                                                                minRows={2}
                                                                fullWidth

                                                            />
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            xs={10}
                                                            container
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            style={{ marginTop: 5 }}
                                                        >
                                                            <TextField
                                                                id="observacao"
                                                                variant="standard"
                                                                value={inUpdate.observacao}
                                                                onChange={(e) => setInUpdate({ ...inUpdate, "observacao": e.target.value })}
                                                                label="Observações"

                                                                multiline
                                                                minRows={2}
                                                                fullWidth

                                                            />
                                                        </Grid>


                                                        <Grid
                                                            container
                                                            direction="row"
                                                            justifyContent="flex-end"
                                                            align="flex-end"
                                                            item xs={8}
                                                            style={{ marginTop: 5 }}
                                                        >


                                                            <div {...getRootArquivoProps1()} style={dropzoneStyles}>
                                                                <input {...getInputArquivoProps1()} />
                                                                <Typography align="center" variant="h7">
                                                                    Anexo
                                                                </Typography>
                                                            </div>


                                                        </Grid>




                                                        <Grid
                                                            item
                                                            xs={11}
                                                            container
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            spacing={2}
                                                            style={{ marginTop: 5 }}
                                                        >
                                                            <IconButton color="success" onClick={() => handleUpdateRow()} >
                                                                <SaveIcon />
                                                            </IconButton>
                                                            <IconButton color="error" onClick={() => handleCancelUpdate()} >
                                                                <CancelIcon />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                )}

                                            </Grid>

                                            <Grid
                                                container
                                                direction="row"
                                                item xs={6}
                                                alignItems="center"
                                                justifyContent="center"
                                                style={{
                                                    margin: 0,
                                                    border: '1px solid #000',// Cor azul escuro e borda pontilhada
                                                    borderRadius: 4, // Borda levemente arredondada
                                                    width: '100%',
                                                }}

                                            >
                                                <Grid
                                                    item xs={12}
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    container
                                                >

                                                    <Grid
                                                        item xs={10}
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        container
                                                    >
                                                        <Typography variant="body1" style={{ fontSize: 18 }}>
                                                            <strong>Pagamentos</strong>
                                                        </Typography>

                                                    </Grid>
                                                    <Grid
                                                        item xs={2}
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        container
                                                    >

                                                        <IconButton color="primary" onClick={() => handleOpenCadastrarPagamento()}>
                                                            <AddIcon />
                                                        </IconButton>
                                                    </Grid>

                                                </Grid>

                                                <Grid
                                                    container
                                                    direction="row"
                                                    item xs={12}
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    style={{ width: '100%', margin: 0, padding: 0, color: 'black' }}
                                                >

                                                    <MaterialReactTable
                                                        columns={columnsPagamentos}
                                                        data={pagamentos}
                                                        enableTopToolbar={false}
                                                        enableBottomToolbar={false}
                                                        enablePagination={false}
                                                        enableColumnFilters={false}
                                                        enableColumnActions={false}
                                                        sortable={false}
                                                        enableRowActions={true}
                                                        enableSorting={false}
                                                        enableRowSelection={false}
                                                        color={'black'}
                                                        paginationDisplayMode={'pages'}
                                                        getRowId={(row) => row.id_item_analise}
                                                        initialState={{
                                                            pagination: { pageSize: 20, pageIndex: 0 },
                                                            showGlobalFilter: true,
                                                            color: 'black'
                                                        }}
                                                        muiTableContainerProps={{ sx: { maxHeight: "3000px", color: 'black' } }}
                                                        muiTableBodyRowProps={{
                                                            sx: {
                                                                height: 35,
                                                                color: 'black' // Define a cor do texto para preto
                                                            },
                                                        }}
                                                        enableColumnFilterModes={false}
                                                        enableExpandAll={true}
                                                        enableColumnPinning={true}
                                                        enableColumnResizing={true}
                                                        muiPaginationProps={{
                                                            rowsPerPageOptions: [20, 50, 100],
                                                            variant: 'outlined',
                                                        }}
                                                        enableFullScreenToggle={true}
                                                        muiTablePaperProps={({ table }) => ({
                                                            style: {
                                                                zIndex: table.getState().isFullScreen ? 1000 : undefined,
                                                                color: 'black',
                                                            },
                                                        })}

                                                        renderRowActionMenuItems={({ row, table }) => [
                                                            < Tooltip title="Editar">
                                                                <IconButton size="small" onClick={() => handleAtualizarPagamento(row.original)}>
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>,
                                                            <Tooltip title="Deletar">
                                                                <IconButton size="small" color="error" onClick={() => handleClickDeletePagamento(row.original)}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        ]}


                                                    />

                                                </Grid>







                                            </Grid>

                                            <Grid
                                                container
                                                direction="row"
                                                item xs={12}
                                                alignItems="center"
                                                justifyContent="center"
                                                style={{ width: '100%', margin: 0, padding: 0, color: 'black' }}
                                            >


                                                <Grid
                                                    item xs={12}
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    container
                                                >

                                                    <Grid
                                                        item xs={5}
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        container
                                                    >
                                                        <Typography variant="body1" style={{ fontSize: 18 }}>
                                                            <strong>{"Atributos Financeiros (Juros, Descontos, Acrescimos)"}</strong>
                                                        </Typography>

                                                    </Grid>
                                                    <Grid
                                                        item xs={5}
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        container
                                                    >

                                                        <IconButton color="primary" onClick={() => handleOpenCadastrarAtributo()}>
                                                            <AddIcon />
                                                        </IconButton>
                                                    </Grid>

                                                </Grid>


                                                <Grid
                                                    container
                                                    direction="row"
                                                    item xs={12}
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    style={{ width: '100%', margin: 0, padding: 0, color: 'black' }}
                                                >

                                                    <MaterialReactTable
                                                        columns={columnsAtributos}
                                                        data={atributos}
                                                        enableTopToolbar={false}
                                                        enableBottomToolbar={false}
                                                        enablePagination={false}
                                                        enableColumnFilters={false}
                                                        enableColumnActions={false}
                                                        sortable={false}
                                                        enableRowActions={true}
                                                        enableSorting={false}
                                                        enableRowSelection={false}
                                                        color={'black'}
                                                        paginationDisplayMode={'pages'}
                                                        getRowId={(row) => row.id_atributo}
                                                        initialState={{
                                                            pagination: { pageSize: 20, pageIndex: 0 },
                                                            showGlobalFilter: true,
                                                            color: 'black'
                                                        }}
                                                        muiTableContainerProps={{ sx: { maxHeight: "3000px", color: 'black' } }}
                                                        muiTableBodyRowProps={{
                                                            sx: {
                                                                height: 35,
                                                                color: 'black' // Define a cor do texto para preto
                                                            },
                                                        }}
                                                        enableColumnFilterModes={false}
                                                        enableExpandAll={true}
                                                        enableColumnPinning={true}
                                                        enableColumnResizing={true}
                                                        muiPaginationProps={{
                                                            rowsPerPageOptions: [20, 50, 100],
                                                            variant: 'outlined',
                                                        }}
                                                        enableFullScreenToggle={true}
                                                        muiTablePaperProps={({ table }) => ({
                                                            style: {
                                                                zIndex: table.getState().isFullScreen ? 1000 : undefined,
                                                                color: 'black',
                                                            },
                                                        })}

                                                        renderRowActionMenuItems={({ row, table }) => [

                                                            <Tooltip title="Deletar">
                                                                <IconButton size="small" color="error" onClick={() => handleClickDeleteAtributo(row.original)}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        ]}


                                                    />

                                                </Grid>

                                            </Grid>

                                        </Grid>

                                    </Grid>


                                </SwipeableViews>
                            </Grid>
                        </Grid >




                    </React.Fragment >
                }





            </div >




            <Dialog open={openGeradorParcelas} onClose={closeGeradorParcelas} PaperProps={{ style: { maxWidth: '1200px', minWidth: '1000px' } }}>
                <DialogContent>
                    <GeradorParcelas
                        lancamento={lancamento}
                        closeGeradorParcelas={closeGeradorParcelas}
                    />
                </DialogContent>
            </Dialog>


            <Dialog open={openCadastrarPagamento} onClose={closeCadastrarPagamento} PaperProps={{ style: { maxWidth: '1200px', minWidth: '1000px' } }}>
                <DialogContent>
                    <CadastrarPagamento
                        lancamento={lancamento}
                        closeCadastrarPagamento={closeCadastrarPagamento}
                        isEditingPagamento={true}
                        isUpdatePagamento={false}
                    />
                </DialogContent>
            </Dialog>


            <Dialog open={openCadastrarNF} onClose={closeCadastrarNF} PaperProps={{ style: { maxWidth: '1200px', minWidth: '1000px' } }}>
                <DialogContent>
                    <CadastrarNF
                        lancamento={lancamento}
                        closeCadastrarNF={closeCadastrarNF}

                    />
                </DialogContent>
            </Dialog>

            <Dialog open={openCadastrarAtributo} onClose={closeCadastrarAtributo} PaperProps={{ style: { maxWidth: '1200px', minWidth: '1000px' } }}>
                <DialogContent>
                    <CadastrarAtributo
                        lancamento={lancamento}
                        closeCadastrarAtributo={closeCadastrarAtributo}

                    />
                </DialogContent>
            </Dialog>


            <Modal open={atualizarPagamento} onClose={closeCadastrarPagamento}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 2,
                        maxWidth: "80vw",   // até 80% da largura da tela
                        minWidth: "80vw",   // mínimo 80% da largura da tela
                        maxHeight: "80vh",  // até 80% da altura da tela
                        overflowY: "auto",
                    }}
                >
                    <CadastrarPagamento
                        lancamento={lancamento}
                        closeCadastrarPagamento={closeCadastrarPagamento}
                        isEditingPagamento={false}
                        isUpdatePagamento={true}
                        attinUpdatePagamento={inUpdatePagamento}
                    />
                </Box>
            </Modal>




            <Modal
                open={openDadosPagamento}
                onClose={() => setOpenDadosPagamento(false)}
                aria-labelledby="atributos-financeiros"
            >
                {objetoGerenciado?.pre_cotacao ?
                    (<Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            bgcolor: "white",
                            height: "70vh",
                            width: "70vw",
                            overflow: "auto",
                            border: "2px solid black",
                            boxShadow: 24,
                            p: 2,
                        }}
                    >

                        <Typography variant="h6" style={{ marginTop: 5 }}>
                            Atributos Financeiros
                        </Typography>

                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={12}
                            style={{ marginTop: 5 }}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                align="center"
                                item xs={6}
                            >

                                <Autocomplete
                                    id="select-metodos-pagamento"
                                    options={[]}
                                    disableCloseOnSelect
                                    multiple
                                    fullWidth
                                    getOptionLabel={(metodo) => returnDescricaoMetodoPagamento(metodo).replace(/<br \/>/g, '\n')}
                                    value={objetoGerenciado.pre_cotacao.metodos_pagamento}
                                    filterOptions={(options, { inputValue }) => {
                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                        return options.filter((solicitante) => {
                                            const cotacaoText = returnDescricaoMetodoPagamento(solicitante).toLowerCase();
                                            return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label=" Metodos de Pagamento " multiline rows={1} />
                                    )}
                                    renderOption={(option) => (
                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoMetodoPagamento(option).replace(/\n/g, '<br>') }} />
                                    )}
                                    renderTags={(value, getTagProps) =>
                                        value.map((metodo, index) => (
                                            <Chip
                                                label={returnDescricaoMetodoPagamento(metodo).replace(/<br \/>/g, '\n')}
                                                {...getTagProps({ index })}
                                             />
                                        ))
                                    }
                                />
                            </Grid>
                        </Grid>


                        <Box
                            sx={{
                                maxWidth: 900,
                                mx: "auto", // centraliza horizontalmente
                                p: 3,
                                mt: 4,
                                border: "1px solid #ccc",
                                borderRadius: 2,
                                boxShadow: 3,
                                backgroundColor: "#f9f9f9",
                            }}
                        >
                            <Typography variant="h6" align="center" gutterBottom>
                                Condições de Pagamento
                            </Typography>

                            <Grid container spacing={2}>
                                {/* Modalidade */}
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Modalidade</InputLabel>
                                        <Select
                                            value={objetoGerenciado.pre_cotacao.condicao_pagamento}
                                        >
                                            <MenuItem value={0}>Antecipado - À vista</MenuItem>
                                            <MenuItem value={1}>Após receber Nota Fiscal</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Tipo do Intervalo */}
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Tipo do Intervalo</InputLabel>
                                        <Select
                                            value={objetoGerenciado.pre_cotacao.tipo_intervalo}

                                        >
                                            <MenuItem value={0}>Fixo</MenuItem>
                                            <MenuItem value={1}>Variável</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Número de Parcelas */}
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Nº de Parcelas"
                                        value={objetoGerenciado.pre_cotacao.numero_parcelas}
                                    />
                                </Grid>

                                {/* Intervalo de Parcelas */}
                                {objetoGerenciado.pre_cotacao.tipo_intervalo === 0 && (
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Intervalo (dias)"
                                            value={objetoGerenciado.pre_cotacao.intervalo_parcelas}
                                        />
                                    </Grid>
                                )}
                                {objetoGerenciado.pre_cotacao.tipo_intervalo === 1 && (
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Intervalo Variável (dias)"
                                            value={objetoGerenciado.pre_cotacao.intervalo_variavel}
                                        />
                                    </Grid>
                                )}

                                {/* Intervalo da Primeira Parcela */}
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Primeira Parcela (dias)"
                                        value={objetoGerenciado.pre_cotacao.intervalo_primeira_parcela}
                                    />
                                </Grid>

                                {/* Tipo de Divisão */}
                                <Grid item xs={12} sm={3}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Tipo de Divisão</InputLabel>
                                        <Select
                                            value={objetoGerenciado.pre_cotacao.tipo_divisao}
                                        >
                                            <MenuItem value={0}>Igualitária</MenuItem>
                                            <MenuItem value={1}>Variável</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Divisão Variável */}
                                {objetoGerenciado.pre_cotacao.tipo_divisao === 1 && (
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Divisão (%)"
                                            value={objetoGerenciado.pre_cotacao.divisao_variavel}
                                        />
                                    </Grid>
                                )}
                            </Grid>

                            {/* contabancaria */}
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                align="center"
                                item xs={6}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    align="center"
                                    item xs={12}
                                >


                                    <Autocomplete
                                        id="select-fornecedor-recebedor"
                                        options={[]}
                                        fullWidth
                                        style={{ fontSize: '14px' }}
                                        getOptionLabel={(conta) => returnDescricaoBanco(conta).replace(/<br \/>/g, '\n')}
                                        value={objetoGerenciado.pre_cotacao.conta_bancaria}
                                        getOptionSelected={(option, value) => option.id_conta_bancaria === value?.id_conta_bancaria}
                                        filterOptions={(options, { inputValue }) => {
                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                            return options.filter((solicitante) => {
                                                const cotacaoText = returnDescricaoBanco(solicitante).toLowerCase();
                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                            });
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                style={{ fontSize: '14px' }}
                                                InputProps={{ ...params.InputProps, style: { fontSize: '14px' } }}
                                                InputLabelProps={{ style: { fontSize: '14px' } }}
                                                label=" Conta Bancária do Recebedor "
                                                multiline
                                                minRows={2}
                                            />
                                        )}
                                    />




                                </Grid>
                            </Grid>

                        </Box>


                    </Box>
                    ) :
                    (
                        <div /> // placeholder vazio
                    )
                }


            </Modal>

        </div >
    );
}



